// Helper function to detect touch support
const isTouchDevice = () => {
    return (('ontouchstart' in window) 
       || (navigator.maxTouchPoints > 0) 
       || (navigator.msMaxTouchPoints > 0));
};
  
export const vSwipeable = {
    mounted(element, binding) {
        // Skip setup if device doesn't support touch
        if (!isTouchDevice()) return;
        
        const swipeOptions = binding.value || {};
        
        let initialTouchX = 0;
        let initialTouchY = 0;
        let initialTouchTime = 0;
        
        const handleTouchStart = (event) => {
            initialTouchX = event.touches[0].clientX;
            initialTouchY = event.touches[0].clientY;
            initialTouchTime = new Date().getTime();
        };
        
        const handleTouchEnd = (event) => {
        const finalTouchTime = new Date().getTime();
        const elapsedTime = finalTouchTime - initialTouchTime;
        
        // Only process quick swipes
        if (elapsedTime > (swipeOptions.maxSwipeTime || 300)) return;
        
        const deltaX = event.changedTouches[0].clientX - initialTouchX;
        const deltaY = event.changedTouches[0].clientY - initialTouchY;
        
        // Check if it's a clear horizontal swipe
        if (Math.abs(deltaX) > (swipeOptions.minDistance || 80) && 
            Math.abs(deltaX) > (swipeOptions.directionRatio || 2) * Math.abs(deltaY)) {
            if (deltaX > 0) {
                // Swipe right
                if (swipeOptions.onSwipeRight) swipeOptions.onSwipeRight(event);
            } else {
                // Swipe left
                if (swipeOptions.onSwipeLeft) swipeOptions.onSwipeLeft(event);
            }
            
            // Prevent default actions
            event.preventDefault();
        }
        };
        
        element.addEventListener('touchstart', handleTouchStart, { passive: true });
        element.addEventListener('touchend', handleTouchEnd, { passive: false });
        
        // Store handlers for cleanup
        element._swipeHandlers = {
            start: handleTouchStart,
            end: handleTouchEnd
        };
    },

    beforeUnmount(element) {
        // Skip cleanup if we didn't set up handlers or device doesn't support touch
        if (!element._swipeHandlers || !isTouchDevice()) return;
        
        element.removeEventListener('touchstart', element._swipeHandlers.start);
        element.removeEventListener('touchend', element._swipeHandlers.end);
        delete element._swipeHandlers;
    }
};